module.exports = __webpack_public_path__ + "img/Federal-Bank.19ac1e5a.jpg";